import styled from "styled-components";
import React, { FC, useEffect, useLayoutEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useLocation, useNavigate } from "react-router-dom";

import Footer from "../components/Footer/Footer";
import Navigation from "../components/Navigation/Navigation";
import Button, { ButtonThemes } from "../components/Button/Button";
import { useMobile } from "../hooks/useResponsible";
import { Logo, LogoIcon } from "../components/Icons/LogoIcon";

interface PageLayoutProps {
  children: React.ReactNode;
}

const PageLayout: FC<PageLayoutProps> = ({ children }) => {
  const href = window.location.pathname;
  const isMobile = useMobile({ width: 999 });
  gsap.registerPlugin(ScrollTrigger);

  useLayoutEffect(() => {
    const context = gsap.context(() => {
      if (href === "/pricing" || href === "/pricing2" || href === "/pricing3") return;
      if (isMobile) return;

      gsap.to("#navigation-center", {
        scrollTrigger: {
          trigger: "#floating-menu",
          start: `bottom top+=68`,
          end: `bottom bottom`,
          scrub: 1,
        },
        visibility: "visible",
        opacity: 1,
      });
    });

    return () => context.revert();
  }, [href, isMobile]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const hadnleBackClick = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
      return null;
    }
  };

  return (
    <>
      <ButtonWrapper>
        <Button onClick={hadnleBackClick} buttonTheme={ButtonThemes.Secondary} icon={<LogoIcon />} />
      </ButtonWrapper>
      <ContentWrapper>{children}</ContentWrapper>
    </>
  );
};

const ContentWrapper = styled.main`
  font-family: "Montserrat", sans-serif;
  overflow: hidden;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 40px;

  button {
    width: 173px;
    height: 37px;
  }

  svg {
    width: 173px;
    height: 37px;

    path {
      fill: #fff;
    }
  }
`;

export default PageLayout;
